import type { PayloadAction } from "@reduxjs/toolkit";
import type { EmbeddedOsdSettingsState } from "Interfaces";
import { createAppSlice } from "Data/Redux/Store";
import { Colors, DeviceNamePosition } from "Data/Objects/Camera";

const initialState: EmbeddedOsdSettingsState = {
	cameraInfo: {
		resolution: false,
		dateTime: false,
		deviceName: DeviceNamePosition.OFF
	},
	ai: {
		displayMode: false,
		objectColor: Colors.BLACK,
		ruleColor: Colors.BLUE,
		eventColor: Colors.CYAN
	}
};

export const setEmbeddedOsdReducer = (
	state: EmbeddedOsdSettingsState,
	action: PayloadAction<EmbeddedOsdSettingsState>
) => {
	return action.payload;
};

export const getEmbeddedOsd = (state: EmbeddedOsdSettingsState) => {
	return state;
};

const embeddedOsdSlice = createAppSlice({
	name: "embeddedOsd",
	initialState,
	reducers: {
		setEmbeddedOsdAction: setEmbeddedOsdReducer
	},
	selectors: {
		selectEmbeddedOsd: getEmbeddedOsd
	}
});

export default embeddedOsdSlice;

export const { setEmbeddedOsdAction } = embeddedOsdSlice.actions;
export const { selectEmbeddedOsd } = embeddedOsdSlice.selectors;
